module.exports = require("@jswork/next-slate-deserialize");